import Handlebars from 'lib/handlebars.runtime-v4.7.8';

export default Handlebars.registerHelper('lower', function lower(string) {
  return typeof string === 'string' ? string.toLowerCase() : string;
});
